import { Injectable } from '@angular/core';
import { select, Store, Action } from '@ngrx/store';

import * as InvitationsActions from './invitations.actions';
import * as InvitationsFeature from './invitations.reducer';
import * as InvitationsSelectors from './invitations.selectors';

@Injectable()
export class InvitationsFacade {
  /**
   * Combine pieces of state using createSelector,
   * and expose them as observables through the facade.
   */
  loaded$ = this.store.pipe(select(InvitationsSelectors.getInvitationsLoaded));
  allInvitations$ = this.store.pipe(
    select(InvitationsSelectors.getAllInvitations),
  );
  selectedInvitations$ = this.store.pipe(
    select(InvitationsSelectors.getSelected),
  );

  constructor(private readonly store: Store) {}

  /**
   * Use the initialization action to perform one
   * or more tasks in your Effects.
   */
  init() {
    this.store.dispatch(InvitationsActions.init());
  }

  refetch() {
    this.store.dispatch(InvitationsActions.init());
  }
}
